export default __webpack_public_path__ + "static/image-03-330x330-4b110bfe13e967e63932985969e4c970.jpg";